import { __toESM } from "./chunk-B4qE4VCv.mjs";
import { require_monet } from "./monet-BVhQJMm9.mjs";
import { require_Option } from "./Option-D1XhUpjC.mjs";

//#region src/overloadOption.ts
var import_Option = /* @__PURE__ */ __toESM(require_Option());
var import_monet = /* @__PURE__ */ __toESM(require_monet());
const { Maybe, None } = import_monet.default;
/**
* For converting from an fp-ts `Option` to Monet's `Maybe`.
*
* Returns a value that can be used as either an `Option` or a `Maybe`.
*
* @deprecated Switch to `fp-ts` directly or use `convertMonet` functions.
* @private
* @example
* ```ts twoslash
* import * as O from 'fp-ts/lib/Option.js'
* import { Just } from 'monet'
* import { overloadOption } from '@simplisafe/ewok'
* import { pipe } from 'fp-ts/lib/function.js'
*
* overloadOption(O.of(42)).map(n => n + 1) // => Just(43)
*
* pipe(overloadOption(O.of(42)), O.map(n => n + 1)) // => O.Some(43)
* ```
*/
function overloadOption(o) {
	const x = import_Option.fold(() => None(), Maybe.of)(o);
	return Object.assign(x, o);
}
var overloadOption_default = overloadOption;

//#endregion
export { overloadOption_default };